// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CiL9GFykUHWl7A {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  gap: var(--ds-space-250, 20px);
}
.OrJtgMmoQz1VqV {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tCGG56sq6sSIhr {
  font-weight: var(--ds-font-weight-medium, 500);
}
.j7x4OpccguSBY4 {
  text-align: center;
}
.gwXDCA9W1vvpOs {
  display: flex;
  flex-direction: column;
  padding: var(--ds-space-300, 24px) var(--ds-space-600, 48px) var(--ds-space-300, 24px) var(--ds-space-600, 48px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  gap: var(--ds-space-200, 16px);
}
.gwXDCA9W1vvpOs ul {
  margin-left: var(--ds-space-250, 18px);
  list-style-type: disc;
}
.gwXDCA9W1vvpOs ul li::marker {
  font-size: x-small;
}
.CG428nrHNmrPBi {
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 16px;
}
.gfF2pI1uC5mRzI {
  gap: var(--ds-space-100, 8px);
  display: flex;
}
`, ""]);
// Exports
export var freeSelectionInformationModal = `CiL9GFykUHWl7A`;
export var modalHeader = `OrJtgMmoQz1VqV`;
export var modalTitle = `tCGG56sq6sSIhr`;
export var modalDescription = `j7x4OpccguSBY4`;
export var freeLimitsAndUnavailableFeatures = `gwXDCA9W1vvpOs`;
export var subheading = `CG428nrHNmrPBi`;
export var modalFooter = `gfF2pI1uC5mRzI`;
export default ___CSS_LOADER_EXPORT___;
